import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'Home',
            component: () =>
                import ('@/views/Home'),
        },
        {
            path: '/Home', //登录
            name: 'Home',
            component: () =>
                import ('@/views/Home'),
        },

    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js